import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{attrs:{"value":_vm.isActive,"color":_vm.color,"multi-line":_vm.multiLine},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c(VBtn,_vm._b({attrs:{"dark":"","text":"","color":_vm.buttonColor},on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},'v-btn',attrs,false),[_vm._v(_vm._s(_vm.label))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }